import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useErrorHandler } from 'react-error-boundary';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { useSelector } from 'react-redux';

import JobOpeningCard from '../../components/job_opening_card/JobOpeningCard';
import LogoutMenu from '../../components/logout/LogoutMenu';
import Loader from '../../components/loader/Loader';
import TriangleBg from '../../assets/images/TriangleBg.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    background: 'linear-gradient(to bottom,#6bf98d, #16c7ff)',
    overflow: 'hidden',
    overflowY: 'auto',
    paddingTop: 18,
    marginTop: -110,
  },
  openPositionHeading: {
    textAlign: 'start',
    textTransform: 'capitalize',
    padding: 20,
    paddingLeft: 0,
  },
}));

const OpenPositions = (props) => {
  const { mobileView } = props;
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const { openPositions } = useSelector((state) => state?.openPositionsState);

  const classes = useStyles();

  const handleJobCardClick = (jobId) => {
    try {
      navigate('/jobs/job-details', { state: { jobId } });
    } catch (error) {
      errorHandler(error);
    }
  };

  const Contents = () => {
    return (
      <div
        style={{
          paddingLeft: mobileView ? 40 : 60,
          paddingRight: mobileView ? 40 : 60,
          background: `url(${TriangleBg})`,
        }}
      >
        {!mobileView && (
          <div style={{ textAlign: 'right', marginRight: -35,marginTop:'1rem' }}>
            <LogoutMenu />
          </div>
        )}
        <Stack>
          <Typography
            variant='h6'
            className={classes.openPositionHeading}
            fontWeight={600}
          >
            Share Jobs with your friends
          </Typography>
          {openPositions ? (
            openPositions?.map((position) => (
              <JobOpeningCard
                key={position.id}
                position={position}
                onClick={(jobId) => handleJobCardClick(jobId)}
                mobileView={mobileView}
              />
            ))
          ) : (
            <Loader />
          )}
        </Stack>
      </div>
    );
  };

  return mobileView ? (
    <div className={classes.container}>
      <Contents />
    </div>
  ) : (
    <Scrollbars
      id='sidebar'
      className={classes.container}
      style={{ height: 'calc(100vh - 1px)' }}
    >
      <Contents />
    </Scrollbars>
  );
};

export default OpenPositions;
